import { render } from "./ChatMessage.vue?vue&type=template&id=7ba7f778&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"

import "./ChatMessage.vue?vue&type=style&index=0&id=7ba7f778&scoped=true&lang=css"
import "./ChatMessage.vue?vue&type=style&index=1&id=7ba7f778&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba7f778"]])

export default __exports__